/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import {
  hideModal,
  fetchConsentDocumentForParticipant,
  updateAddNoteConsentGid,
  postNewNote,
  clearNewNoteForm
} from '../../actions/actions';
import AddNoteModal from './note.add.component';
import DocumentsService from '../documents/documents.service';

export const mapStateToProps = (state) => {
  return {
    consentGid: state.newNote.consentGid,
    consentingGid: state.newNote.consentingGid,
    documentsMetadata: DocumentsService.prepareDocumentsMetadata(state.documents.items).documentsMetadata,
    consentDocumentData: state.newNote.consentDocumentData,
    error: state.newNote.error
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    createNewNote: (consentingGid, note) => {
      dispatch(postNewNote(consentingGid, note));
    },
    backToView: () => {
      dispatch(clearNewNoteForm());
      dispatch(hideModal());
    },
    loadConsentDocumentsForParticipant: (consentGid) => {
      dispatch(fetchConsentDocumentForParticipant(consentGid));
    },
    consentDocumentSelectionChanged: (consentGid) => {
      dispatch(updateAddNoteConsentGid(consentGid));
      dispatch(fetchConsentDocumentForParticipant(consentGid));
    }
  };
};

const AddNoteContainer = connect(mapStateToProps, mapDispatchToProps)(AddNoteModal);

export default AddNoteContainer;
